import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-measurerdashboard',
  templateUrl: './measurerdashboard.component.html',
  styleUrls: ['./measurerdashboard.component.scss']
})
export class MeasurerdashboardComponent implements OnInit {
  AddMeasurerItemsForm: FormGroup;
  clients: any;
  clientstofilter: any;
  dataSource: any;
  displayedColumns: string[] = [
    "ItemName",
    "Code",
    "ItemType",
    "Branch",
    "Action"
  ];
  data: object[] = [];
  ClientId: any;
  AllBranchs: any[]=[];
  MeasurerItems: any[]=[];
  MeasurerItemstofilter: any;
  MeasurerItemsBranch: any[]=[];
  HintMessage:string


ItemTypes:any[]=[]
  MeasurerItemsId: any;
  UserInfo: any;
  hum: boolean = false;
  constructor(private _formBuilder: FormBuilder,  public GeneralService: GeneralService
    ) { 
      this.UserInfo = JSON.parse(localStorage.getItem('currentuser'));

      this.initForm();
this.onBranchValueChanges()
this.onItemTypeValueChanges()
this.onItemValueChanges()
       this.UserInfo=JSON.parse(localStorage.getItem('currentuser'));
       this.ClientId=this.UserInfo.clientid;
    } 

    updateHumValueValidation() {
      const humValueControl = this.AddMeasurerItemsForm.get('HumValue');
      
      if (this.hum) {
        humValueControl?.setValidators([Validators.required]);
      } else {
        humValueControl?.clearValidators();
      }
      
      humValueControl?.updateValueAndValidity();
    }


    initForm() {
      this.AddMeasurerItemsForm = this._formBuilder.group({
        Item: [{ value: null, disabled: true }, Validators.required],
        ItemType: [{ value: null, disabled: true }, Validators.required],
        Branch: [null, Validators.required],  
        TempValue: [ null , Validators.required],
        HumValue: [ null]

      });
    }
    onBranchValueChanges(): void {
      this.AddMeasurerItemsForm.get('Branch')?.valueChanges.subscribe(branchValue => {
        const ItemTypeControl = this.AddMeasurerItemsForm.get('ItemType');
        if (branchValue) {
          ItemTypeControl?.enable();
        } else {
          ItemTypeControl?.disable();
        }
      });
    }
 
    onItemTypeValueChanges(): void {
      this.AddMeasurerItemsForm.get('ItemType')?.valueChanges.subscribe(ItemTypeValue => {
        const ItemControl = this.AddMeasurerItemsForm.get('Item');
        const MeasureTypeControl = this.AddMeasurerItemsForm.get('MeasureType');

        if (ItemTypeValue) {
      this.MeasurerItemstofilter=this.MeasurerItems.filter(x=>x.Branch==this.AddMeasurerItemsForm.get('Branch').value && x.ItemType==this.AddMeasurerItemsForm.get('ItemType').value)
          ItemControl?.enable();
           const  type =this.ItemTypes.filter(x=>x.id==this.AddMeasurerItemsForm.get('ItemType')?.value);
          if(type[0].humValue == "" || null || !type[0].humValue){
            this.hum = false;
            this.HintMessage=  this.ItemTypes.filter(x=>x.id==ItemTypeValue)[0].hintMessageTemp
          }else{
            this.hum = true;
            this.updateHumValueValidation();
            this.HintMessage=  this.ItemTypes.filter(x=>x.id==ItemTypeValue)[0].hintMessageTemp +
            " and " + this.ItemTypes.filter(x=>x.id==ItemTypeValue)[0].hintMessageHum 

          }
       
          
// if(this.AddMeasurerItemsForm.get('TypeMeasure')?.value == "Temp"){
//   this.HintMessage=  this.ItemTypes.filter(x=>x.id==ItemTypeValue)[0].hintMessageTemp
// }else{
//   this.HintMessage=  this.ItemTypes.filter(x=>x.id==ItemTypeValue)[0].hintMessageHum

// }
          
          // if(ItemTypeValue==1){
          //   this.HintMessage="The temperature cannot exceed 5 °C"
          // }
          // else if(ItemTypeValue==2){
          //   this.HintMessage="The temperature cannot exceed -18 °C"
          // }
          // else if(ItemTypeValue==3){
          //   this.HintMessage="Vegetable Sanitation Must be 100 PPM"
          // }
          // else if(ItemTypeValue==4){
          //   this.HintMessage="Oil cannot exceed 24 %"
          // }
        } else {
          ItemControl?.disable();
        }
      });
    }
    onItemValueChanges(): void {
      this.AddMeasurerItemsForm.get('Item')?.valueChanges.subscribe(ItemValue => {
        const ValueControl = this.AddMeasurerItemsForm.get('Value');
        if (ItemValue) {
          ValueControl?.enable();
        } else {
          ValueControl?.disable();
        }
      });
    }
    GetAllItems(){
    this.GeneralService.getBranchByClientId(this.ClientId).then(res=>{
      this.AllBranchs=res;
      console.log(this.AllBranchs)

    })
    }
    GetAllItemType() {
      this.GeneralService.getallItemType().subscribe(res => {
        this.ItemTypes = res;
        console.log(this.ItemTypes)
        
      });
    }
    GetAllBranchs(){
      this.GeneralService.getBranchByClientId(this.ClientId).then(res=>{
        this.AllBranchs=res;
        console.log(this.AllBranchs)
  
      })
      }
    getallMeasurerItems(){
      const ClientId=this.ClientId
      this.GeneralService.getMeasurerItemsbyclientid(ClientId).then(items=>{
        
        this.MeasurerItems=items;
        this.MeasurerItemstofilter=items
        console.log(this.MeasurerItems)
      })
    }
    
    get fc() {
      return this.AddMeasurerItemsForm.controls;
    }
    ngOnInit() {
      this.getallMeasurerItems();
      this.GetAllBranchs();
      this.GetAllItemType()
    }
    InsertMeasurerItems(){
      const dateObj = new Date(); // Use current date
      const day = dateObj.getDate(); // Get the day
      const month = dateObj.getMonth() + 1; // Get the month (0-based, so add 1)
      const year = dateObj.getFullYear(); // Get the year
      const localDate = new Date(); // Gets the current local date and time

    
      this.GeneralService.checkRecordingLimit(day,month,year,this.AddMeasurerItemsForm.get("Item").value).then(res=>{
        if(!res){
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "You have already recorded this item today",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        else{
       
      // Format the date to "YYYY-MM-DD HH:mm:ss"
      const formattedDate = localDate.getFullYear() + '-' + 
      String(localDate.getMonth() + 1).padStart(2, '0') + '-' + 
      String(localDate.getDate()).padStart(2, '0') + ' ' + 
      String(localDate.getHours()).padStart(2, '0') + ':' + 
      String(localDate.getMinutes()).padStart(2, '0') + ':' + 
      String(localDate.getSeconds()).padStart(2, '0');
const data= {
"Item":this.AddMeasurerItemsForm.get("Item").value,
"ItemType":this.AddMeasurerItemsForm.get("ItemType").value,
"clientid":this.ClientId,
"Branch":this.AddMeasurerItemsForm.get("Branch").value,
"tempvalue":this.AddMeasurerItemsForm.get("TempValue").value,
"humvalue":this.AddMeasurerItemsForm.get("HumValue").value,
"UserId":this.UserInfo.id,
"Month":month,
"Year":year,
"Day":day,
"CreationDate":formattedDate,
"ByUser":true
}
this.GeneralService.addMeasurerValueForClient(data).then(res=>{
Swal.fire({
icon: "success",
title: "Success ",
showConfirmButton: false,
timer: 1500,
});
this.AddMeasurerItemsForm.reset();
this.HintMessage=""
})
        }

      })


    }
    addMeasurerItems(){
      console.log(this.AddMeasurerItemsForm.value)
      if (this.AddMeasurerItemsForm.status == "VALID") {
        
          this.InsertMeasurerItems()
        
      }
       else {
        this.AddMeasurerItemsForm.markAllAsTouched();
      }
    }


    
}




